import types from './types';

const getUnNumberList = () => ({
  type: types.GET_UN_NUMBER_LIST
});

export default {
  getUnNumberList
};
